import { render, staticRenderFns } from "./buyDialog.vue?vue&type=template&id=3fd282f6&scoped=true"
import script from "./buyDialog.vue?vue&type=script&lang=js"
export * from "./buyDialog.vue?vue&type=script&lang=js"
import style0 from "./buyDialog.vue?vue&type=style&index=0&id=3fd282f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd282f6",
  null
  
)

export default component.exports